module.exports = __webpack_public_path__ + "img/first.720b042c.png";